import React from 'react';
import { Container, Stack } from '@fiverr-private/layout_components';
import { Text } from '@fiverr-private/typography';
import { BUYABLE_TYPE, PriceWithFees } from '@fiverr-private/price_upfront_components';
import { useLocalizationContext } from '../../hooks/LocalizationContext';

export interface HourlyRateProps {
    hourlyRateInUsdCents: number;
    fontSize?: React.ComponentProps<typeof Text>['size'];
    fontColor?: React.ComponentProps<typeof Stack>['color'];
}

export const HourlyRate = ({ hourlyRateInUsdCents, fontSize = 'b_lg', fontColor = 'grey_1100' }: HourlyRateProps) => {
    const { currency } = useLocalizationContext();

    if (!hourlyRateInUsdCents) {
        return null;
    }

    return (
        <Container fontWeight="normal">
            <PriceWithFees
                netPrice={hourlyRateInUsdCents / 100}
                currency={currency}
                buyableType={BUYABLE_TYPE.HOURLY}
                typographyProps={{
                    color: fontColor,
                    size: fontSize,
                }}
            />
        </Container>
    );
};
